import allowedSubscriptionStatus from '../lib/allowedSubscriptionStatus';
import CannotEnrollReasonTypes from '../constants/CannotEnrollReasonTypes';
import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { ENROLLED_IN_PROSPECTING_AGENT, UNKNOWN_SALES_SUBSCRIPTION_STATUS } from 'sequences-lib/constants/EligibilityErrorTypes';
const getIneligibleContactReason = ({
  contact,
  eligibility
}) => {
  const errorType = eligibility.get('errorType');
  if (errorType === ENROLLED_IN_PROSPECTING_AGENT) {
    return CannotEnrollReasonTypes.ENROLLED_IN_PROSPECTING_AGENT;
  }
  const skipSubscriptionStatusCheck = errorType === UNKNOWN_SALES_SUBSCRIPTION_STATUS;
  const subscriptionStatus = eligibility.getIn(['metadata', 'salesSubscriptionStatus']);
  if (!allowedSubscriptionStatus(subscriptionStatus) && !skipSubscriptionStatusCheck) {
    return subscriptionStatus;
  }
  const email = getProperty(contact, 'email');
  if (!email) {
    return CannotEnrollReasonTypes.MISSING_EMAIL_ADDRESS;
  }
  if (eligibility.get('cannotCommunicate')) {
    return CannotEnrollReasonTypes.CANNOT_COMMUNICATE;
  }
  const currentEnrollment = eligibility.getIn(['metadata', 'activeEnrollment']);
  if (currentEnrollment !== null && currentEnrollment !== undefined) {
    // Does not account for editing enrollments
    return CannotEnrollReasonTypes.ALREADY_ENROLLED;
  }
  return null;
};
export default getIneligibleContactReason;